import React from 'react'
import { Stack, Typography, Container } from "@mui/material";
import { useModo } from "../hooks/useModo";
import { useNavigate } from "react-router-dom";
import { QuestionaryLevel } from "../components/QuestionaryLevel";
import { QuestionaryLevelInfo } from "../components/QuestionaryLevelInfo";
import modoExperto from '../images/modoExperto.png'
import modoIniciacion from '../images/modoIniciacion.png'
import { useTranslation } from "react-i18next"
import colors from '../theme/colors'
import { useSecurity } from "../hooks/useSecurity"


export const SeleccionarModo = () => {
    const { cambiarModoIniciacion, cambiarModoExperto } = useModo();
    const navigate = useNavigate();
    const { t } = useTranslation();
    useSecurity();

    return (
        <>
            <Typography variant="h1" fontWeight={'bold'}>
                    {t("SeleccionarModoCuestionario.seleccionarCuestionario")}
            </Typography>
            <Stack
                direction={{ xs: 'column', md: 'column', lg: 'column' }}
                justifyContent="center"
                alignItems="center"
                border={"2px solid" + colors.primary}
                borderRadius={10}
                padding={'2em'}
                spacing={2}
                sx={{ height: '100%', marginBottom: '2em' }}
                    >
                <Typography>
                    {t("SeleccionarModoCuestionario.introduccion") + " "}
                </Typography>
                <QuestionaryLevelInfo/>
                <Stack direction={{ xs: 'column', md: 'row', lg: 'row' }} >
                    <QuestionaryLevel image={modoIniciacion} buttonText={t("SeleccionarModoCuestionario.noCumplePuntos")} setModo={cambiarModoIniciacion} />
                    <QuestionaryLevel image={modoExperto} buttonText={t("SeleccionarModoCuestionario.cumplePuntos")} setModo={cambiarModoExperto} />
                </Stack>
            </Stack>
        </>
    );
};
